//* 꽃집에서 부고를 조회하기 위한 페이지(전화주문용)
import { FC, useMemo } from 'react';

import { useRecoilValue, useSetRecoilState } from 'recoil';

import {
  prefillOfOrder,
  usePhoneOrderLookup,
} from '@service/seller/components/PhoneOrderLookupSection';
import { SellerCallOrderTable } from '@service/seller/containers/SellerCallOrderTable/SellerCallOrderTable';
import { sellerFeventAppliedearchValueAtom } from '@service/seller/containers/SellerFeventSearchTable/state/sellerFeventSearchTable.atom';
import { sellerCallOrderPrefillAtom } from '@service/seller/state/sellerCallOrderPrefill.atom';
import { useCallOrderListHook } from '@shared/api/callOrder/callOrder.hook';
import { useFeventByShopHook } from '@shared/api/fevent/fevent.hook';
import { feventByShopStateSelectorFamily } from '@shared/api/fevent/fevent.selector';
import { Loading } from '@shared/components/Loading';
import { notificateSuccess } from '@shared/plugIn/ant-notification/ant-notifiaction';
import { notificationInstanceAtom } from '@shared/state/atom/notification.atom';
import { useParams } from 'react-router-dom';

import { SellerFeventSearchBar } from '../containers/SellerFeventSearchTable/SellerFeventSearchBar';
import { SellerFeventSearchTable } from '../containers/SellerFeventSearchTable/SellerFeventSearchTable';
import { useSellerTopNavHook } from '../hooks/useSellerTopNavHook';

const SellerBugoSearchPage: FC = function SellerBugoSearchPage() {
  const { shopId } = useParams();

  useSellerTopNavHook('부고 조회');
  useFeventByShopHook(`${shopId}`);
  useCallOrderListHook();

  const feventState = useRecoilValue(feventByShopStateSelectorFamily(`${shopId}`));
  const setAppliedSearchValue = useSetRecoilState(sellerFeventAppliedearchValueAtom);
  const setCallOrderPrefill = useSetRecoilState(sellerCallOrderPrefillAtom);
  const notifiacationInstance = useRecoilValue(notificationInstanceAtom);

  //* 검색줄은 부고검색 옆칸에, 결과 카드는 그 아래 전체 폭에 두려고 조각으로 받는다
  const { searchBar: phoneLookupBar, searchResult: phoneLookupResult } =
    usePhoneOrderLookup({
      title: '전화 온 번호로 찾기',
      description: '(전에 넣던 주문의 주문자 정보·문구를 그대로 가져옵니다)',
      selectLabel: '주문자·문구 담기',
      //* 담아두면 전화주문생성 모달의 정보 입력 단계에서 자동으로 채워진다
      onSelect: (shopOrder) => {
        setCallOrderPrefill(prefillOfOrder(shopOrder));
        notificateSuccess(
          notifiacationInstance,
          '담았습니다. 전화주문생성 정보 입력 단계에서 자동으로 채워집니다.',
        );
      },
      //* 그 주문이 걸린 상가를 아래 검색표에 바로 띄운다
      onFindBugo: (shopOrder) => {
        const deceasedName = shopOrder.bugo?.fevent?.deceasedInfo?.name;
        if (deceasedName) setAppliedSearchValue(deceasedName);
      },
    });

  const feventSearchTable = useMemo(() => {
    if (feventState.status === 'success' && feventState.data) {
      const feventList = feventState.data;
      return <SellerFeventSearchTable feventList={feventList}></SellerFeventSearchTable>;
    } else {
      <div className="center-box">
        <Loading />
      </div>;
    }
  }, [feventState.data, feventState.status]);

  return (
    <div className="mx-auto flex w-[100vw] max-w-6xl px-4 pb-8 pt-8 sm:w-fit sm:px-6 lg:px-8">
      <div className="w-full space-y-8 font-medium">
        {/* 전화번호(좌) · 부고(우) 검색을 한 줄에 */}
        <div className="grid grid-cols-1 items-start gap-x-6 gap-y-6 sm:grid-cols-2">
          {phoneLookupBar}
          <SellerFeventSearchBar />
        </div>
        {/* 번호검색 결과 카드는 전체 폭 */}
        {phoneLookupResult}
        {feventSearchTable}
        <SellerCallOrderTable />
      </div>
    </div>
  );
};

export default SellerBugoSearchPage;
